var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.181,
    height: 33.181,
    viewBox: "0 0 33.181 33.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_people",
    "data-name": "vuesax/bulk/people",
    transform: "translate(-620 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people",
    transform: "translate(620 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H33.181V33.181H0Z",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.134,7.977a1.021,1.021,0,0,0-.29,0,4,4,0,1,1,.29,0Z",
    transform: "translate(20.102 2.765)",
    fill: "#fd4082",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.793,6.488A8.585,8.585,0,0,1,.069,7.649,9.029,9.029,0,0,0,.885,3.93,8.5,8.5,0,0,0,0,.087,8.623,8.623,0,0,1,5.779,1.234C7.963,2.672,7.963,5.036,5.793,6.488Z",
    transform: "translate(22.95 13.836)",
    fill: "#fd4082",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M3.857,7.977a1.021,1.021,0,0,1,.29,0,4,4,0,1,0-.29,0Z",
    transform: "translate(5.046 2.765)",
    fill: "#fd4082",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M6.3,3.93a9,9,0,0,0,.816,3.76A8.543,8.543,0,0,1,1.638,6.5c-2.184-1.452-2.184-3.816,0-5.267A8.49,8.49,0,0,1,7.168.059,8.79,8.79,0,0,0,6.3,3.93Z",
    transform: "translate(2.758 13.835)",
    fill: "#fd4082",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M4.936,9.5a1.562,1.562,0,0,0-.359,0A4.751,4.751,0,1,1,9.512,4.756,4.726,4.726,0,0,1,4.936,9.5Z",
    transform: "translate(11.821 12.443)",
    fill: "#fd4082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M1.566,1.192c-2.088,1.4-2.088,3.691,0,5.074a8.448,8.448,0,0,0,8.655,0c2.088-1.4,2.088-3.691,0-5.074A8.448,8.448,0,0,0,1.566,1.192Z",
    transform: "translate(10.697 23.61)",
    fill: "#fd4082"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.294dbfc1ddc828b68bbea6763515400f.svg";
export { ForwardRef as ReactComponent };